import { useLayoutEffect, useState } from "react";

export const PREVIEW_NATURAL_WIDTH = 400;
export const PREVIEW_NATURAL_HEIGHT = 687;

export default function usePreviewScale(containerRef, naturalHeight = PREVIEW_NATURAL_HEIGHT) {
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;

    const updateScale = () => {
      const available = el.clientHeight;
      if (!available) return;
      setScale(Math.min(1, available / naturalHeight));
    };

    updateScale();
    const observer = new ResizeObserver(updateScale);
    observer.observe(el);
    return () => observer.disconnect();
  }, [naturalHeight]);

  return scale;
}
